module.exports = "body {\r\n  padding-top: 50px;\r\n}\r\n\r\ntable.floatThead-table {\r\n  border-top: none;\r\n  border-bottom: none;\r\n  background-color: #fff;\r\n}\r\n\r\nth {\r\n  position: sticky;\r\n  top: -10px;\r\n  background: white;\r\n}\r\n\r\n.table-responsive {\r\n  height:60vh !important;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/gls/gl-ledger/gl-ledger.component.css
// module id = ./src/app/components/gls/gl-ledger/gl-ledger.component.css
// module chunks = main